// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const HoldList = lazy(() => import('pages/holdUnhold/hold/holdList'));

const HoldRoute = (
  <Route path={routeName.hold}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.HOLD_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <HoldList />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default HoldRoute;
